var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isIndicator)?_c('div',{class:_vm.$style.container},[_c('div',{class:_vm.$style.label},[_vm._v(_vm._s(_vm.label))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }